import type { DataTableHeader } from '@/types/vuetify';
import i18n from '@/plugins/i18n';

export function createAlertPageHeaders(): DataTableHeader[] {
    const t = i18n.global.t;

    return [
        {
            title: '',
            value: 'select',
            key: 'select',
            align: 'center',
            sortable: false,
            minWidth: 20,
            width: 20,
            headerProps: { class: 'px-0' },
            cellProps: { class: 'px-0' },
        },
        {
            title: t('alerts.date'),
            value: 'created_at',
            key: 'created_at',
            align: 'start',
            sortable: true,
            nowrap: true,
            headerProps: { class: 'nowrap alerts-col-date' },
            cellProps: { class: 'alerts-col-date' },
        },
        {
            title: t('alerts.alert'),
            value: 'code',
            key: 'code',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap alerts-col-code' },
            cellProps: { class: 'alerts-col-code' },
        },
        {
            title: t('alerts.user'),
            value: 'uniqUserName',
            key: 'uniqUserName',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap alerts-col-uniq-user' },
            cellProps: { class: 'alerts-col-uniq-user' },
        },
        {
            title: t('alerts.book'),
            value: 'bookmakerName',
            key: 'bookmakerName',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap alerts-col-book', 'data-tooltip': t('bets.tooltips.bookTooltip') },
            cellProps: { class: 'alerts-col-book' },
        },
        {
            title: t('alerts.account'),
            value: 'accountName',
            key: 'accountName',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap alerts-col-account' },
            cellProps: { class: 'alerts-col-account' },
        },
        {
            title: t('alerts.game'),
            value: 'gameDisplay',
            key: 'gameDisplay',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap alerts-col-game' },
            cellProps: { class: 'alerts-col-game' },
        },
        {
            title: t('alerts.errorMessage'),
            value: 'text',
            key: 'text',
            align: 'start',
            sortable: false,
            headerProps: { class: 'nowrap v-data-table-column--align-center alerts-col-text' },
            cellProps: { class: 'alerts-col-text' },
        },
        {
            title: t('alerts.dm'),
            value: 'isDismissed',
            key: 'isDismissed',
            align: 'center',
            sortable: false,
            nowrap: true,
            headerProps: { 'data-tooltip': t('alerts.dmTooltip'), class: 'nowrap alerts-col-dm' },
            cellProps: { class: 'alerts-col-dm' },
        },
        {
            title: t('alerts.user'),
            value: 'userName',
            key: 'userName',
            align: 'start',
            sortable: false,
            nowrap: true,
            headerProps: { class: 'nowrap alerts-col-user-name' },
            cellProps: { class: 'alerts-col-user-name' },
        },
        {
            title: '',
            value: 'infoMenu',
            key: 'infoMenu',
            align: 'end',
            sortable: false,
            nowrap: true,
            width: 24,
            cellProps: { class: 'pl-0 pr-1' },
        },
    ];
}
